module.exports = __webpack_public_path__ + "assets/img/ic-btn-tri.eee1973b.svg";